module.exports = __webpack_public_path__ + "img/eldo.d8ebffe0.jpeg";